var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baich" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增/编辑批量操作",
            width: "80%",
            visible: _vm.dialogVisible,
            "destroy-on-close": "",
            top: "5vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: { model: _vm.form, "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "操作简述：",
                    prop: "title",
                    rules: [
                      {
                        required: true,
                        message: "请填写操作简述",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.form.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "title", $$v)
                      },
                      expression: "form.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "操作类型：",
                    prop: "opType",
                    rules: [
                      {
                        required: true,
                        message: "请选择操作类型",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.opType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "opType", $$v)
                        },
                        expression: "form.opType",
                      },
                    },
                    _vm._l(_vm.handleTypeEnum, function (rad) {
                      return _c(
                        "el-radio",
                        { key: rad.value, attrs: { label: rad.value } },
                        [_vm._v(_vm._s(rad.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.opType === 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "状态：" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.form.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "status", $$v)
                            },
                            expression: "form.status",
                          },
                        },
                        _vm._l(_vm.handleStatusEnum, function (opt) {
                          return _c("el-option", {
                            key: opt.value,
                            attrs: { label: opt.label, value: opt.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商品类型：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.productType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "productType", $$v)
                        },
                        expression: "form.productType",
                      },
                    },
                    _vm._l(_vm.batchGoodsTypeEnum, function (rad) {
                      return _c(
                        "el-radio",
                        { key: rad.value, attrs: { label: rad.value } },
                        [_vm._v(_vm._s(rad.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "选择商品：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "goods-type",
                      on: { change: _vm.handleIsExcel },
                      model: {
                        value: _vm.form.isExcel,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "isExcel", $$v)
                        },
                        expression: "form.isExcel",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _c("div", { staticClass: "goods-type-upload" }, [
                          _c("div", [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                },
                              },
                              [
                                _vm.form.isExcel === 1
                                  ? _c(
                                      "ButtonUploadExcel",
                                      { attrs: { onSuccess: _vm.onSuccess } },
                                      [_c("span", [_vm._v("上传商品")])]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "20px" },
                                    attrs: { type: "primary", plain: "" },
                                    on: { click: _vm.downloadTemplate },
                                  },
                                  [_vm._v("下载模板")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-top": "10px",
                                  color: "#666",
                                },
                              },
                              [
                                _c("p", [
                                  _vm._v(
                                    "SKU ID、成本价、分销客户成本价、分销售价（上下架只需SKU ID）"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [_vm._v("支持扩展名：.xlsx .csv")]),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        {
                          staticStyle: { "margin-top": "20px" },
                          attrs: { label: 0 },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("span", [_vm._v("指定商品")]),
                              _vm._v(" "),
                              _c(
                                "el-table",
                                { attrs: { data: _vm.tableData.list } },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      "min-width": "100",
                                      prop: "id",
                                      label: "ID",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      "min-width": "100",
                                      prop: "skuCode",
                                      label: "编码",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      "min-width": "100",
                                      prop: "skuName",
                                      label: "名称",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      "min-width": "100",
                                      prop: "otPrice",
                                      label: "零售价(原价)",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      "min-width": "100",
                                      prop: "listStatus",
                                      label: "上架状态",
                                      formatter: function (row) {
                                        return row.listStatus === 0
                                          ? "下架"
                                          : "上架"
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      "min-width": "100",
                                      prop: "brandName",
                                      label: "品牌",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      "min-width": "100",
                                      prop: "supplierName",
                                      label: "供应商",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.form.opType === 2
                                    ? _c("el-table-column", {
                                        attrs: {
                                          "min-width": "100",
                                          prop: "cost",
                                          label: "成本价",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-input", {
                                                    model: {
                                                      value: scope.row.cost,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "cost",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.cost",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2700141442
                                        ),
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.opType === 2
                                    ? _c("el-table-column", {
                                        attrs: {
                                          "min-width": "160",
                                          prop: "defaultPrice",
                                          label: "默认售价",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-input-number", {
                                                    attrs: {
                                                      controls: false,
                                                      size: "mini",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.defaultPrice,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "defaultPrice",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.defaultPrice",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1684771378
                                        ),
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.opType === 2
                                    ? _c("el-table-column", {
                                        attrs: {
                                          "min-width": "100",
                                          prop: "supplyPrice",
                                          label: "分销成本价",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-input-number", {
                                                    attrs: {
                                                      controls: false,
                                                      size: "mini",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.supplyPrice,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "supplyPrice",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.supplyPrice",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2934490186
                                        ),
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.form.opType === 2
                                    ? _c("el-table-column", {
                                        attrs: {
                                          "min-width": "100",
                                          prop: "distributionPrice",
                                          label: "分销售价",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-input-number", {
                                                    attrs: {
                                                      controls: false,
                                                      size: "mini",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row
                                                          .distributionPrice,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "distributionPrice",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.distributionPrice",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1061867299
                                        ),
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      "min-width": "100",
                                      label: "操作",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteRecord(
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("移除")]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "text",
                                    size: "mini",
                                    disabled: _vm.form.isExcel === 1,
                                  },
                                  on: { click: _vm.addGoods },
                                },
                                [_vm._v("+ 添加商品")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "客户选择：" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", multiple: "" },
                      model: {
                        value: _vm.form.customerIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "customerIds", $$v)
                        },
                        expression: "form.customerIds",
                      },
                    },
                    _vm._l(_vm.merchantEnum, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "定时操作：",
                    prop: "exeType",
                    rules: [
                      {
                        required: true,
                        message: "请选择定时操作",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "time",
                      staticStyle: { height: "36px" },
                      on: { change: _vm.changeTime },
                      model: {
                        value: _vm.form.exeType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "exeType", $$v)
                        },
                        expression: "form.exeType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("立即同步"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-radio",
                        { staticClass: "fixed-time", attrs: { label: 2 } },
                        [
                          _c(
                            "div",
                            [
                              _c("span", [_vm._v("定时同步")]),
                              _vm._v(" "),
                              _vm.form.exeType === 2
                                ? _c(
                                    "el-form-item",
                                    { attrs: { label: "选择时间：" } },
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          type: "datetime",
                                          placeholder: "选择日期时间",
                                          "value-format": "yyyy-MM-dd HH:mm:ss",
                                        },
                                        model: {
                                          value: _vm.form.exeTime,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "exeTime", $$v)
                                          },
                                          expression: "form.exeTime",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "info" }, on: { click: _vm.close } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("SelectGoodsVue", {
        ref: "selectGoodsVueRef",
        on: { update: _vm.updateTableDate },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }